module.exports = __webpack_public_path__ + "static/media/ammar.f1e2b4e2.png";